import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-slideshow-image';
import { Image } from './Image';
import { media } from '../theme';
import { arrayToChunks } from '../utils/arrayToChunks';
import { navVerticalOffset } from './HorizontalNewsBar';
import { vr } from '../utils';

export function Sponsors({ data, isPreviewMode }) {
  const [ activeIndex, setActiveIndex ] = useState(0);

  const [ slides, setSlides ] = useState([]);

  useEffect(() => {
    const randomizedSlides = data.sort(() => Math.random() - 0.5);
    setSlides(arrayToChunks(5, randomizedSlides));
  }, []);

  return (
    <Hero>
      { (Array.isArray(slides) && slides.length > 0) && (
        <Slider onChange={(oldIndex, newIndex) => setActiveIndex(newIndex)} duration={3500} indicators={false} arrows={false}>
          {slides.map((slide, index) => (

            <div className="container">
              <div className="each-fade">
                {slide.map(({ link, image }) => (
                  <a href={link && !isPreviewMode ? link : '/'} rel="nofollow" tabIndex={index === activeIndex ? 0 : -1}>
                    <Image src={image} style={{ paddingBottom: 0, height: 64 }} innerStyle={{ width: 'auto', position: 'static' }} />
                  </a>
                ))}
              </div>
            </div>

          ))}
        </Slider>
      )}
    </Hero>
  );
}

const Hero = styled.div`
  position: relative;
  padding-top: ${vr(1)};
  
  @media ${media.landscapeL} {
    margin-top: ${navVerticalOffset};
  }

  .gatsby-image-wrapper {
    height: inherit;
  }

  * {
    height: inherit;
  }
`;

const Slider = styled(Fade)`
  .react-slideshow-container {
    display: flex;
    align-items: center;

    @media ${media.desktopS} {
      height: 64px;
    }

    .nav {
      height: 30px;
      background: rgba(255, 255, 255, 0.6);
      width: 30px;
      z-index: 10;
      text-align: center;
      cursor: pointer;
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;

      span {
        display: block;
        width: 10px;
        height: 10px;
        border-color: #000;
        border-style: solid;
        transform: rotate(45deg)
      }

      &.disabled {
        span {
          border-color: #666
        }

        &:hover {
          cursor: not-allowed
        }
      }

      &:hover {
        background: white;
        color: #666
      }

      &:first-of-type {
        margin-right: -30px;
        border-right: 0;
        border-top: 0;

        span {
          margin-left: 5px;
          border-right: 0;
          border-top: 0
        }
      }

      &:last-of-type {
        margin-left: -30px
      }
    }

    .custom-nav {
      z-index: 10;

      span {
        margin-right: 5px;
        border-left: 0;
        border-bottom: 0
      }
    }

    & + div.indicators {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;

      & > .each-slideshow-indicator {
        width: 7px;
        height: 7px;
        margin: 0 5px 10px;
        border-radius: 50%;
        background: #ccc;
        cursor: pointer;

        &:hover {
          background: #666
        }

        &.active {
          background: #000
        }
      }
    }
  }

  .react-slideshow-fade-wrapper {
    width: 100%;
    overflow: hidden;

    .react-slideshow-fade-images-wrap {
      display: flex;
      flex-wrap: wrap;

      > div {
        position: relative;
        opacity: 0;
        display: flex;
        align-items: center;


      }
    }
  }

  .react-slideshow-wrapper {
  
    .slide {
      width: 100%;
      overflow: hidden;
    }
    
    .images-wrap {
      display: flex;
      flex-wrap: wrap;
    }
  }

  a {
    display: block;
  }

  .each-fade {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;

    a {
      margin: 10px;
    }
    
    @media ${media.desktopS} {
      justify-content: space-between;
      flex-wrap: nowrap;

      a {
        margin: 0;
      }
    }
  }

  .react-slideshow-zoom-wrapper {
    width: 100%;
    overflow: hidden;

    .zoom-wrapper {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;

      > div {
        position: relative;
        display: flex
      }
    }
  }
`;
